/* RUOK 2026 — scroll reveal.
   Guarded so multiple section includes are harmless.

   Deliberately a scroll sweep rather than IntersectionObserver: IO never
   delivers a callback for an element that goes from below the fold to above
   it in a single jump (fast flick, anchor link, restored scroll position),
   which left those elements stuck at opacity 0. The sweep reveals anything
   at or above the fold line, so nothing can be skipped. */
(function () {
  if (window.__ruokMotionInit) { return; }
  window.__ruokMotionInit = true;

  document.documentElement.classList.add('ruok-js');

  var pending = [];
  var ticking = false;

  function collect() {
    pending = Array.prototype.slice.call(document.querySelectorAll('.ruok-reveal:not(.is-in)'));
  }

  function sweep() {
    ticking = false;
    var line = window.innerHeight * 0.92;
    var still = [];

    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      if (el.getBoundingClientRect().top < line) { el.classList.add('is-in'); }
      else { still.push(el); }
    }
    pending = still;

    if (!pending.length) { stop(); }
  }

  function onScroll() {
    if (ticking) { return; }
    ticking = true;
    window.requestAnimationFrame(sweep);
  }

  function start() {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function stop() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  }

  function init() {
    collect();
    if (!pending.length) { return; }
    start();
    sweep();
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  // Images finishing late can shift positions; re-check once everything settles.
  window.addEventListener('load', onScroll);

  // Re-scan when the theme editor injects or reloads a section
  document.addEventListener('shopify:section:load', function () {
    collect();
    if (pending.length) { start(); sweep(); }
  });
})();

/* Hero CTA -> the product grid.

   THIS HANDLER IS NOW A FALLBACK, NOT THE MAIN PATH. Owner reported on 7 Aug
   2026 that the buttons scrolled to the wrong place or did nothing at all on an
   iPhone; it could not be reproduced in WebKit, throttled or otherwise. So the
   common case no longer runs any of this code:

     - `#main-collection` is a real id on the grid container
     - ruok.css sets `html { scroll-behavior: smooth }`
     - ruok.css sets `#main-collection { scroll-margin-top: 132px / 84px }`

   which means the plain anchor already scrolls smoothly and already clears the
   sticky header, computed by the browser DURING the scroll rather than from a
   pixel guess made at click time. Anything JS adds here is a way to break it —
   and it did break it once before, when preventDefault() ran ahead of a
   scrollTo() that Safari <15.4 silently ignored.

   What is left runs only when the anchor genuinely has nothing to point at:
   Shopify names the grid section `shopify-section-template--<id>__main` and that
   numeric id changes when a template is rebuilt, so a template that lost its
   `#main-collection` still needs the id-proof "find the first product link"
   search. */
(function () {
  if (window.__ruokScrollInit) { return; }
  window.__ruokScrollInit = true;

  // Height of whatever is pinned to the top of the viewport, so the first row
  // doesn't land underneath a sticky header.
  function stickyOffset() {
    var best = 0;
    var nodes = document.querySelectorAll(
      '[id^="shopify-section"], header, .header, .site-header, .header-wrapper');
    for (var i = 0; i < nodes.length; i++) {
      var cs = window.getComputedStyle(nodes[i]);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') { continue; }
      var r = nodes[i].getBoundingClientRect();
      if (r.top <= 4 && r.height > best && r.height < 260) { best = r.height; }
    }
    return best;
  }

  function firstProductCard() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.closest('.ruok-hero')) { continue; }          // never the hero itself
      return a.closest('li, article, .relative, [class*="grid"]') || a;
    }
    return null;
  }

  // Capture phase: a theme/app script that calls stopPropagation() on anchor clicks
  // would otherwise swallow this before it reached document in the bubble phase.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-ruok-scroll]') : null;
    if (!btn) { return; }

    var href = btn.getAttribute('href') || '';

    // Not a same-page anchor -> it is a real destination like
    // /collections/catering, which is what the CTA on the eleven rebuilt pages
    // uses. Never touch those: hijacking one would stop the button navigating
    // at all. (Harmless until now only because those pages happen to contain no
    // product links, so the search below returned null and fell through.)
    if (href.charAt(0) !== '#') { return; }

    // The anchor has a real target -> the browser does it better than we can.
    // Hands off: no preventDefault, no scrollTo, nothing to go wrong.
    var target = null;
    try { target = document.querySelector(href); } catch (err) { target = null; }
    if (target) { return; }

    var card = firstProductCard();
    if (!card) { return; }                    // nothing to scroll to — let the href run

    // Object-form scrollTo is IGNORED SILENTLY on Safari < 15.4. Calling
    // preventDefault() before discovering that killed the anchor too, so the button
    // did nothing at all. Feature-detect, and keep the two-argument form — which is
    // universally supported — as the fallback.
    var smoothOK = 'scrollBehavior' in document.documentElement.style;
    var reduce = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = Math.max(0, window.pageYOffset + card.getBoundingClientRect().top
                          - stickyOffset() - 16);

    e.preventDefault();
    if (smoothOK && !reduce) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      window.scrollTo(0, top);
    }
  }, true);
})();
